import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Section from '../../common/Section';
import Anchor from '../utils/Anchor';
import TextBlockWithIcon from '../textBlock/TextBlockWithIcon';
import CollapsibleItem from './CollapsibleItem';

const Wrapper = styled(Section)`
  padding: var(--default-vertical-padding) var(--default-horizontal-padding);
  background-color: ${props => props.backgroundColor || 'inherit'};
  color: ${props => props.color || 'inherit'};
  fill: ${props => props.color || 'var(--c-white)'};
`;

const Content = styled.div`
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
`;

const CollapsibleList = ({ content }) => {
  const { title, textBlock, blocks, blockId, backgroundColor, textColor, borderColor } = content;

  return (
    <React.Fragment>
      <Anchor id={blockId} />
      <Wrapper padding="0" backgroundColor={backgroundColor} color={textColor}>
        {get(textBlock, 'fields') && (
          <TextBlockWithIcon
            content={textBlock.fields}
            srcBlockName={`Collapsible List - ${title}`}
          />
        )}
        {blocks && (
          <Content>
            {blocks.map(block => {
              return (
                <CollapsibleItem
                  key={block.sys.id}
                  content={block.fields}
                  borderColor={borderColor}
                />
              );
            })}
          </Content>
        )}
      </Wrapper>
    </React.Fragment>
  );
};

CollapsibleList.propTypes = {
  content: PropTypes.object,
};

export default CollapsibleList;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/collapsibleBlock/CollapsibleList.js